var exports = {
  "az": "Box__Eu8ZhH",
  "wy": "Box_1__FCIfqp",
  "EY": "Text__Mx_n9K",
  "pv": "Box_2__JF3mZE",
  "w9": "Box_3__8Ki8Lz",
  "pQ": "Box_4__j9HNsB",
  "ws": "Box_5__8QYgI-",
  "K0": "IconButton__oSybPp",
  "UJ": "ActionMenuOverlay__TXsKDq",
};

module.exports = exports;
